import { render, staticRenderFns } from "./WrapKeepAlive.vue?vue&type=template&id=c70cd486&scoped=true&"
import script from "./WrapKeepAlive.vue?vue&type=script&lang=js&"
export * from "./WrapKeepAlive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70cd486",
  null
  
)

export default component.exports